import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import config from '../appconfig/config.json';

const BizMailingAddress = (props) => { 
    const {addType, response} = props
   
    return(
        <div>
            {addType === config.addTypeForeign &&
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine1}
                    id={'addline1'} name={response.companydetails.RegBizMailAddr.Address_Line1 !==null? response.companydetails.RegBizMailAddr.Address_Line1:''}/>

                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine2}
                    id={'addline1'} name={response.companydetails.RegBizMailAddr.Address_Line2 !==null? response.companydetails.RegBizMailAddr.Address_Line2:''}/>  
            </div>}
            {addType === config.addTypeLocal &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                    id={'blk'} name={response.companydetails.RegBizMailAddr.Block_Number !== null? response.companydetails.RegBizMailAddr.Block_Number:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.companydetails.RegBizMailAddr.Street_Name !==null? response.companydetails.RegBizMailAddr.Street_Name:''} />
                             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.FlrNum} 
                    id={'lvl'} name={response.companydetails.RegBizMailAddr.Storey_Number !==null? response.companydetails.RegBizMailAddr.Storey_Number:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.companydetails.RegBizMailAddr.Unit_Number !==null? response.companydetails.RegBizMailAddr.Unit_Number:''}  />
                               
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.companydetails.RegBizMailAddr.Building_Name !==null? response.companydetails.RegBizMailAddr.Building_Name:''}  />

                  

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                    id={'ctry'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeLockedBag &&
            <div>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPOName'} leftLabelName={comdetailsdata.label.PostOffice} 
                    id={'postoffName'} name={response.companydetails.RegBizMailAddr.Post_Office_Name !== null? response.companydetails.RegBizMailAddr.Post_Office_Name:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLockBagNo'} leftLabelName={comdetailsdata.label.LockedBagNo}
                    id={'lockbagno'} name={response.companydetails.RegBizMailAddr.Locked_Bag_Number !==null? response.companydetails.RegBizMailAddr.Locked_Bag_Number:''} />
                 
                 <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeGodown &&
            <div>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.companydetails.RegBizMailAddr.Building_Name !==null? response.companydetails.RegBizMailAddr.Building_Name:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblStoreyName'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'storeyName'} name={response.companydetails.RegBizMailAddr.Storey_Number !==null? response.companydetails.RegBizMailAddr.Storey_Number:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.companydetails.RegBizMailAddr.Unit_Number !==null? response.companydetails.RegBizMailAddr.Unit_Number:''}  />
                 
              <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.companydetails.RegBizMailAddr.Street_Name !==null? response.companydetails.RegBizMailAddr.Street_Name:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblGdNo'} leftLabelName={comdetailsdata.label.GodownNo}
                    id={'gdno'} name={response.companydetails.RegBizMailAddr.Godown_Number !==null? response.companydetails.RegBizMailAddr.Godown_Number:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeMultiStorery &&
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                    id={'blk'} name={response.companydetails.RegBizMailAddr.Block_Number !== null? response.companydetails.RegBizMailAddr.Block_Number:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.companydetails.RegBizMailAddr.Building_Name !==null? response.companydetails.RegBizMailAddr.Building_Name:''}  />
                             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.StoreyNo} 
                    id={'lvl'} name={response.companydetails.RegBizMailAddr.Storey_Number !==null? response.companydetails.RegBizMailAddr.Storey_Number:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.companydetails.RegBizMailAddr.Unit_Number !==null? response.companydetails.RegBizMailAddr.Unit_Number:''}  />
                 
                 <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.companydetails.RegBizMailAddr.Street_Name !==null? response.companydetails.RegBizMailAddr.Street_Name:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                    id={'ctry'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeLotMukim &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.companydetails.RegBizMailAddr.Street_Name !==null? response.companydetails.RegBizMailAddr.Street_Name:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLotMukim'} leftLabelName={comdetailsdata.label.LotMukimNo}
                    id={'lotMukim'} name={response.companydetails.RegBizMailAddr.Lot_Mukim_Number !==null? response.companydetails.RegBizMailAddr.Lot_Mukim_Number:''} />
                 
                 <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypePObox &&
            <div>
            <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

            <Field component={CusFormLabel} 
                    leftLabelId={'lblBoxNo'} leftLabelName={comdetailsdata.label.BoxNo}
                    id={'boxno'} name={response.companydetails.RegBizMailAddr.Box_Number !==null? response.companydetails.RegBizMailAddr.Box_Number:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPostOffice'} leftLabelName={comdetailsdata.label.PostOffice}
                    id={'postoffice'} name={response.companydetails.RegBizMailAddr.Post_Office_Name !==null? response.companydetails.RegBizMailAddr.Post_Office_Name:''} />
                 
                 <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeHouseShopWalkupApmt &&
            <div>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.companydetails.RegBizMailAddr.Building_Name !==null? response.companydetails.RegBizMailAddr.Building_Name:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblHouseNo'} leftLabelName={comdetailsdata.label.HouseNo} 
                    id={'hno'} name={response.companydetails.RegBizMailAddr.House_Number !==null? response.companydetails.RegBizMailAddr.House_Number:''}  />
                 
                <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.companydetails.RegBizMailAddr.Street_Name !==null? response.companydetails.RegBizMailAddr.Street_Name:''} />

                 <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}

            {addType === config.addTypeWindowDeli &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.companydetails.RegBizMailAddr.Postal_Code !==null? response.companydetails.RegBizMailAddr.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblWindelino'} leftLabelName={comdetailsdata.label.WinDeliNo} 
                    id={'wdlino'} name={response.companydetails.RegBizMailAddr.Window_Delivery_Number !==null? response.companydetails.RegBizMailAddr.Window_Delivery_Number:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostOffice'} leftLabelName={comdetailsdata.label.PostOffice} 
                    id={'postoffice'} name={response.companydetails.RegBizMailAddr.Post_Office_Name !==null? response.companydetails.RegBizMailAddr.Post_Office_Name:''}  />
                 
              <Field component={CusFormLabel} 
                    leftLabelId={'lblstate'} leftLabelName={comdetailsdata.label.State}
                    id={'state'} name={'SINGAPORE'}/>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblCnty'} leftLabelName={comdetailsdata.label.Country}
                    id={'cnty'} name={'SINGAPORE'}/>
            </div>}
        </div>
    )
}

export default BizMailingAddress